// https://devdocs.io/dom_events/unhandledrejection
import { addWindowEvent } from '../../utils/dom'
import { warn } from '../../application/console'

function globalPromiseRejectionHandler(event) {
  // eslint-disable-line no-shadow
  const { reason, promise } = event
  warn(`Unhandled Promise rejection caught: '${reason}'!`, { event, reason, promise })
}

export default function initGlobalPromiseRejectionHandler() {
  return addWindowEvent('unhandledrejection', globalPromiseRejectionHandler)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/initGlobalRejectionHandler.js